import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d6795e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row ui-espaco-campos" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = {
  class: "",
  title: "Há gerador de energia instalado?"
}
const _hoisted_5 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "",
  title: "Observações"
}
const _hoisted_8 = { class: "ant-row ui-espaco-campos" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = {
  class: "",
  title: "Transformadores instalados?"
}
const _hoisted_11 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_15 = { style: {"margin-top":"15px","display":"flex","align-items":"center"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Tipos:", -1))
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-12 ui-espaco-campos-interno" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Potência Total", -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  style: {"display":"block","margin-top":"10px"},
  class: "ui-campo-instrucao"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  style: {"display":"block","margin-top":"10px"},
  class: "ui-campo-instrucao"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  style: {"display":"block","margin-top":"10px"},
  class: "ui-campo-instrucao"
}
const _hoisted_25 = { key: 2 }
const _hoisted_26 = {
  class: "",
  title: "Observações"
}
const _hoisted_27 = { class: "ant-row ui-espaco-campos" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_29 = {
  class: "",
  title: "Compressores de ar?"
}
const _hoisted_30 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ui-espaco-campos-interno" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ui-campo-instrucao" }, "Quantidade", -1))
const _hoisted_35 = ["disabled"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16 ui-espaco-campos-interno" }, null, -1))
const _hoisted_37 = { key: 2 }
const _hoisted_38 = {
  class: "",
  title: "Observações"
}
const _hoisted_39 = { class: "ant-row ui-espaco-campos" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_41 = {
  class: "",
  title: "Sistema de para-raios (SPDA) instalado?"
}
const _hoisted_42 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = {
  class: "",
  title: "Observações"
}
const _hoisted_45 = { class: "ant-row ui-espaco-campos" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_47 = {
  class: "",
  title: "Existe algum registro de sobrecargas ou falhas elétricas recentes?"
}
const _hoisted_48 = {
  key: 0,
  class: "ui-manual-preenchimento-texto"
}
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  class: "",
  title: "Observações"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    titulo: "SEÇÃO 5 – INFRAESTRUTURA ELÉTRICA E MECÂNICA",
    "class-titulo": 'ui-card-info-titulo-rope'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao5.possuiGeradorEnergiaVisivel,
                        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedSecao5.possuiGeradorEnergiaVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao5.possuiGeradorEnergiaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao5.possuiGeradorEnergiaEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao5.possuiGeradorEnergiaEnviarEmail,
                            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedSecao5.possuiGeradorEnergiaEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao5.possuiGeradorEnergiaEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Há gerador de energia instalado? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiGeradorEnergia')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao5.possuiGeradorEnergiaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao5.possuiGeradorEnergia,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.computedSecao5.possuiGeradorEnergia = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao5.possuiGeradorEnergiaVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao5.possuiGeradorEnergia,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.computedSecao5.possuiGeradorEnergia = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiGeradorEnergia)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiGeradorEnergia), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao5.possuiGeradorEnergiaVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("label", _hoisted_7, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao5.possuiGeradorEnergiaObservacoesVisivel,
                              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedSecao5.possuiGeradorEnergiaObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao5.possuiGeradorEnergiaObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao5.possuiGeradorEnergiaObservacoes,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedSecao5.possuiGeradorEnergiaObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao5.possuiTransformadoresVisivel,
                        "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedSecao5.possuiTransformadoresVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao5.possuiTransformadoresVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao5.possuiTransformadoresEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao5.possuiTransformadoresEnviarEmail,
                            "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedSecao5.possuiTransformadoresEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao5.possuiTransformadoresEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Transformadores instalados? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiTransformadores')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao5.possuiTransformadoresVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao5.possuiTransformadores,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.computedSecao5.possuiTransformadores = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao5.possuiTransformadoresVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao5.possuiTransformadores,
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.computedSecao5.possuiTransformadores = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiTransformadores)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiTransformadores), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao5.possuiTransformadoresVisivel && _ctx.computedSecao5.possuiTransformadores))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao5.transformadorTipoSeco,
                              "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedSecao5.transformadorTipoSeco) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Seco")
                              ]),
                              _: 1
                            }, 8, ["checked"]),
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao5.transformadorTipoOleo,
                              "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedSecao5.transformadorTipoOleo) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Óleo")
                              ]),
                              _: 1
                            }, 8, ["checked"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedSecao5.transformadorPotencia) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_19), [
                            [_vModelText, _ctx.computedSecao5.transformadorPotencia]
                          ])
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_20, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao5.transformadorTemAnaliseCromatograficaVisivel,
                              "onUpdate:checked": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedSecao5.transformadorTemAnaliseCromatograficaVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Tem análise cromatográfica "),
                        (_ctx.computedSecao5.transformadorTemAnaliseCromatograficaVisivel)
                          ? (_openBlock(), _createBlock(_component_a_checkbox, {
                              key: 0,
                              checked: _ctx.computedSecao5.transformadorTemAnaliseCromatografica,
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.computedSecao5.transformadorTemAnaliseCromatografica = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Sim")
                              ]),
                              _: 1
                            }, 8, ["checked"]))
                          : _createCommentVNode("", true),
                        _createTextVNode(),
                        (_ctx.computedSecao5.transformadorTemAnaliseCromatograficaVisivel)
                          ? (_openBlock(), _createBlock(_component_a_checkbox, {
                              key: 1,
                              checked: !_ctx.computedSecao5.transformadorTemAnaliseCromatografica,
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.computedSecao5.transformadorTemAnaliseCromatografica = false))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Não")
                              ]),
                              _: 1
                            }, 8, ["checked"]))
                          : _createCommentVNode("", true),
                        _createTextVNode(),
                        ((_ctx.computedSecao5.transformadorTemAnaliseCromatograficaVisivel && _ctx.computedSecao5.transformadorTemAnaliseCromatografica))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              _createTextVNode("Última análise: "),
                              _createVNode(_component_selecionar_data, {
                                style: {"width":"150px"},
                                "data-selecionada": _ctx.computedSecao5.transformadorDataAnaliseCromatografica,
                                "onUpdate:dataSelecionada": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.computedSecao5.transformadorDataAnaliseCromatografica) = $event))
                              }, null, 8, ["data-selecionada"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_22, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao5.transformadorTemAnaliseTermografiaVisivel,
                              "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.computedSecao5.transformadorTemAnaliseTermografiaVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Tem análise termografia "),
                        (_ctx.computedSecao5.transformadorTemAnaliseTermografiaVisivel)
                          ? (_openBlock(), _createBlock(_component_a_checkbox, {
                              key: 0,
                              checked: _ctx.computedSecao5.transformadorTemAnaliseTermografia,
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.computedSecao5.transformadorTemAnaliseTermografia = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Sim")
                              ]),
                              _: 1
                            }, 8, ["checked"]))
                          : _createCommentVNode("", true),
                        _createTextVNode(),
                        (_ctx.computedSecao5.transformadorTemAnaliseTermografiaVisivel)
                          ? (_openBlock(), _createBlock(_component_a_checkbox, {
                              key: 1,
                              checked: !_ctx.computedSecao5.transformadorTemAnaliseTermografia,
                              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.computedSecao5.transformadorTemAnaliseTermografia = false))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Não")
                              ]),
                              _: 1
                            }, 8, ["checked"]))
                          : _createCommentVNode("", true),
                        _createTextVNode(),
                        ((_ctx.computedSecao5.transformadorTemAnaliseTermografiaVisivel && _ctx.computedSecao5.transformadorTemAnaliseTermografia))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                              _createTextVNode("Última análise: "),
                              _createVNode(_component_selecionar_data, {
                                style: {"width":"150px"},
                                "data-selecionada": _ctx.computedSecao5.transformadorDataAnaliseTermografia,
                                "onUpdate:dataSelecionada": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.computedSecao5.transformadorDataAnaliseTermografia) = $event))
                              }, null, 8, ["data-selecionada"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_24, [
                        _createTextVNode("Na sala do transformador possui detector de fumaça ? "),
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.computedSecao5.transformadorSalaPossuiDetectorFumaca,
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.computedSecao5.transformadorSalaPossuiDetectorFumaca = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sim")
                          ]),
                          _: 1
                        }, 8, ["checked"]),
                        _createTextVNode(),
                        _createVNode(_component_a_checkbox, {
                          checked: !_ctx.computedSecao5.transformadorSalaPossuiDetectorFumaca,
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.computedSecao5.transformadorSalaPossuiDetectorFumaca = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Não")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao5.possuiTransformadoresVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao5.possuiTransformadoresObservacoesVisivel,
                              "onUpdate:checked": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.computedSecao5.possuiTransformadoresObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao5.possuiTransformadoresObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao5.possuiTransformadoresObservacoes,
                            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.computedSecao5.possuiTransformadoresObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao5.possuiCompressoresArVisivel,
                        "onUpdate:checked": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.computedSecao5.possuiCompressoresArVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao5.possuiCompressoresArVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao5.possuiCompressoresArEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao5.possuiCompressoresArEnviarEmail,
                            "onUpdate:checked": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.computedSecao5.possuiCompressoresArEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao5.possuiCompressoresArEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Compressores de ar? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiCompressoresAr')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao5.possuiCompressoresArVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao5.possuiCompressoresAr,
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.computedSecao5.possuiCompressoresAr = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao5.possuiCompressoresArVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao5.possuiCompressoresAr,
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.computedSecao5.possuiCompressoresAr = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiCompressoresAr)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiCompressoresAr), 1))
                  : _createCommentVNode("", true),
                ((_ctx.computedSecao5.possuiCompressoresArVisivel && _ctx.computedSecao5.possuiCompressoresAr))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.computedSecao5.compressoresQtd) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, _hoisted_35), [
                            [_vModelText, _ctx.computedSecao5.compressoresQtd]
                          ])
                        ]),
                        _hoisted_36
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao5.possuiCompressoresArVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao5.possuiCompressoresArObservacoesVisivel,
                              "onUpdate:checked": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.computedSecao5.possuiCompressoresArObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao5.possuiCompressoresArObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao5.possuiCompressoresArObservacoes,
                            "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.computedSecao5.possuiCompressoresArObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("label", _hoisted_41, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao5.sistemaSpdaInstaladoVisivel,
                        "onUpdate:checked": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.computedSecao5.sistemaSpdaInstaladoVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao5.sistemaSpdaInstaladoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao5.sistemaSpdaInstaladoEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao5.sistemaSpdaInstaladoEnviarEmail,
                            "onUpdate:checked": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.computedSecao5.sistemaSpdaInstaladoEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao5.sistemaSpdaInstaladoEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Sistema de para-raios (SPDA) instalado? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[37] || (_cache[37] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('sistemaSpdaInstalado')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao5.sistemaSpdaInstaladoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao5.sistemaSpdaInstalado,
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.computedSecao5.sistemaSpdaInstalado = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao5.sistemaSpdaInstaladoVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao5.sistemaSpdaInstalado,
                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.computedSecao5.sistemaSpdaInstalado = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.sistemaSpdaInstalado)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.ManualPreenchimentoInspecao.sistemaSpdaInstalado), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao5.sistemaSpdaInstaladoVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao5.sistemaSpdaInstaladoObservacoesVisivel,
                              "onUpdate:checked": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.computedSecao5.sistemaSpdaInstaladoObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao5.sistemaSpdaInstaladoObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao5.sistemaSpdaInstaladoObservacoes,
                            "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.computedSecao5.sistemaSpdaInstaladoObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("label", _hoisted_47, [
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Apresentar este campo no relatório?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesVisivel,
                        "onUpdate:checked": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesVisivel) = $event))
                      }, null, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  (_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesVisivel)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top",
                        title: _ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesEnviarEmail
                            ? 'Remover do E-mail para Envio'
                            : 'Incluir no E-mail para Envio'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesEnviarEmail,
                            "onUpdate:checked": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesEnviarEmail) = $event)),
                            class: _normalizeClass(["ui-check-email", {
                                'ui-check-email-marcado': _ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesEnviarEmail
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, { nome: "email" })
                            ]),
                            _: 1
                          }, 8, ["checked", "class"])
                        ]),
                        _: 1
                      }, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Existe algum registro de sobrecargas ou falhas elétricas recentes? "),
                  _createVNode(_component_a_tooltip, {
                    placement: "top",
                    title: "Manual de preenchimento"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "ui-manual-preenchimento",
                        onClick: _cache[44] || (_cache[44] = _withModifiers(($event: any) => (_ctx.alternarManualPreenchimento('possuiRegistroSobrecargasFalhasEletricasRecentes')), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_icone, { nome: "manual-preenchimento" })
                      ])
                    ]),
                    _: 1
                  }),
                  _createTextVNode(),
                  (_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 1,
                        checked: _ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentes,
                        onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentes = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sim")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  (_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesVisivel)
                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                        key: 2,
                        checked: !_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentes,
                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentes = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Não")
                        ]),
                        _: 1
                      }, 8, ["checked"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.manuaisPreenchimento.possuiRegistroSobrecargasFalhasEletricasRecentes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.ManualPreenchimentoInspecao.possuiRegistroSobrecargasFalhasEletricasRecentes), 1))
                  : _createCommentVNode("", true),
                (_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesVisivel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Apresentar este campo no relatório?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesObservacoesVisivel,
                              "onUpdate:checked": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesObservacoesVisivel) = $event))
                            }, null, 8, ["checked"])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Observações:")
                      ]),
                      (_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesObservacoesVisivel)
                        ? (_openBlock(), _createBlock(_component_a_textarea, {
                            key: 0,
                            "auto-size": true,
                            value: _ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesObservacoes,
                            "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.computedSecao5.possuiRegistroSobrecargasFalhasEletricasRecentesObservacoes) = $event)),
                            disabled: _ctx.props.bloquearCampos
                          }, null, 8, ["value", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}